"use strict";
/**
 * @module Services.TopicViews
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetTopicViewResult = void 0;
/**
 * The result type of TopicView GET_TOPIC_VIEW service
 */
var GetTopicViewResult = /** @class */ (function () {
    /**
     * Create a new GetTopicViewResult instance
     *
     * @param result  the topic view
     */
    function GetTopicViewResult(result) {
        this.result = result;
    }
    return GetTopicViewResult;
}());
exports.GetTopicViewResult = GetTopicViewResult;
